import { useCallback } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import { SubActivityEdit } from '../sub-activity/sub-activity-edit';
import { EditProps } from './fill-in-blanks.constants';
import FillInBlanksEditFields from './fill-in-blanks-edit-fields';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';

const FillInBlanksEdit = (props: EditProps) => {
  const { openDrawer, editModeTargetElement, setEditModeTargetElement } =
    useActivityBuilderContext();

  const {
    id,
    sectionId,
    type,
    sort,
    subActivityProperties,
    properties,
    version,
  } = props;

  const handleSetEditMode = useCallback(
    (elementId: string) => {
      openDrawer({ componentId: id });
      setEditModeTargetElement(elementId);
    },
    [id, setEditModeTargetElement, openDrawer]
  );

  return (
    <SubActivityEdit
      id={id}
      component={{
        id,
        type,
        sort,
        properties,
        sectionId,
        language: LANGUAGE_CODE_EN_AU,
        version,
        __typename: 'ActivitiesFillInBlanksResponseComponent',
      }}
      subActivityDetails={subActivityProperties}
    >
      {() => (
        <>
          {properties.fillInBlanks.sentences.length === 0 ? (
            <ComponentEmptyButton
              onClick={() => openDrawer({ componentId: id })}
              buttonText="Add Fill in the Blanks"
              isSmall
            />
          ) : (
            <FillInBlanksEditFields
              {...props}
              editModeTargetElement={editModeTargetElement}
              setEditModeTargetElement={handleSetEditMode}
            />
          )}
        </>
      )}
    </SubActivityEdit>
  );
};

export default FillInBlanksEdit;
